import { useEffect } from "react";
const importScript = (resourceUrl: string, callback?: Function) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = resourceUrl;
    script.async = true;
    script.addEventListener("load", () => {
      if (callback) callback();
    });
    if (Array.from(document.scripts).every(s => s.src != resourceUrl)) {
      document.body.appendChild(script);
    }
    return () => {
      // document.body.removeChild(script);
    };
  }, [resourceUrl]);
};
export default importScript;
